<template>
  <div class="profile">
    <div class="has-text-centered is-centered">
      <p class="title is-3" style="">
        Attendee Details
      </p>
    </div>
    <b-message type="is-info is-light" class="my-3">
      Please ensure that your name, date of birth, and gender match your
      government issued ID.
    </b-message>
    <b-message type="is-danger is-light" class="my-3">
  <p><strong>REAL ID/Passport required for U.S. Domestic Travel.</strong></p>
  <p><strong>Valid Passport required for International Travel.</strong></p>
</b-message>
    <b-notification
      type="is-danger is-light"
      class="my-3"
      v-if="validationErrors.length > 0"
    >
      <h4 class="is-size-5">Please correct the following errors:</h4>
      <div class="content">
        <ul>
          <li v-for="(validationError, index) in validationErrors" :key="index">
            {{ validationError }}
          </li>
        </ul>
      </div>
    </b-notification>
    <div class="columns is-mobile">
      <div class="column sect">
        <b-field label="First Name">
          <b-input
            v-model="profile.firstName"
            required
            validation-message="Please enter a valid name"
            pattern="[a-zA-Z]*"
          ></b-input>
        </b-field>
        <b-field label="Middle Name (optional)">
          <b-input
            v-model="profile.middleName"
            validation-message="Please enter a valid name"
            pattern="[a-zA-Z]*"
          ></b-input>
        </b-field>
        <b-field label="Last Name">
          <b-input
            v-model="profile.lastName"
            required
            validation-message="Please enter a valid name"
            pattern="[a-zA-Z]*"
          ></b-input>
        </b-field>
        <b-field class="my-4">
  <b-checkbox v-model="acknowledgeRealId">
    I acknowledge the name entered matches my Real ID/Passport.
  </b-checkbox>
</b-field>
        <b-field label="Date of Birth">
          <b-input
            v-model="profile.dateOfBirth"
            placeholder="yyyy-mm-dd"
            v-cleave="masks.dob"
            required
          ></b-input>
        </b-field>
        <b-field label="Gender">
          <b-select
            v-model="profile.gender"
            placeholder="Select Gender"
            expanded
          >
            <option value="Male">Male</option>
            <option value="Female">Female</option>
            <option value="Non-Binary">Non-Binary</option>
          </b-select>
        </b-field>
        <b-field label="Mobile Phone">
          <b-input
            v-model="profile.mobilePhone"
            v-cleave="masks.phone"
            required
          ></b-input>
        </b-field>
        <b-field label="Email">
          <b-input v-model="profile.email" type="email" disabled></b-input>
        </b-field>
        <b-field label="TSA PreCheck™ Number (optional)">
          <b-input v-model="profile.tsaPrecheckNumber"></b-input>
        </b-field>
      </div>
    </div>
    <div style=" text-align: center;" class="mb-1">
      <b-button
        size=""
        type="is-light"
        inverted
        outlined
        @click="proceed()"
        style="margin:auto; width: 30%"
      >
        <h5>Save Details</h5>
      </b-button>
    </div>
  </div>
</template>

<script>
import meetingsMixin from "@/mixins/meetingsMixin";
import Cleave from "cleave.js";
const cleave = {
  name: "cleave",
  bind(el, binding) {
    const input = el.querySelector("input");
    input._vCleave = new Cleave(input, binding.value);
  },
  unbind(el) {
    const input = el.querySelector("input");
    input._vCleave.destroy();
  },
};

export default {
  directives: { cleave },
  name: "Profile",
  mixins: [meetingsMixin],
  data: function() {
    return {
      origProfile: {},
      icon: "alpha-i-circle",
      validationErrors: [],
      acknowledgeRealId: false,
      masks: {
        creditCard: { creditCard: true },
        numeral: {
          numeral: true,
          numeralThousandsGroupStyle: "thousand",
          prefix: "$ ",
        },
        date: {
          date: true,
          datePattern: ["m", "y"],
        },
        dob: {
          date: true,
          delimiter: "-",
          datePattern: ["Y", "m", "d"],
        },
        phone: {
          phone: true,
          phoneRegionCode: "US",
          delimiter: "-",
        },
      },
    };
  },
  props: {},
  methods: {
    proceed() {
      let isValid = this.validateForm();

      if (!isValid) return;

      this.$store.commit("meetings/ADD_MEETING_PROFILE", this.profile);
      this.$store.commit("meetings/MEETING_PROFILE_SET", true);
      this.saveRegistrationProfile();
      this.setRegistrationProfile();
      this.goToNextStep("survey");
    },
    validateForm() {
      // console.log('validate form')

      var errors = [];

      if (!this.profile.firstName) {
        errors.push("First name is required");
      }

      if (!this.profile.lastName) {
        errors.push("Last name is required");
      }

      if (!this.profile.dateOfBirth) {
        errors.push("Date of Birth is required");
      }

      if (!this.profile.gender) {
        errors.push("Gender is required");
      }

      if (!this.profile.mobilePhone) {
        errors.push("Mobile phone is required");
      }
      if (!this.acknowledgeRealId) {
    errors.push("You must acknowledge that the name entered matches your Real ID/Passport");
  }

      this.validationErrors = errors;

      if (errors.length > 0) {
        return false;
      }

      return true;
    },
    saveRegistrationProfile() {
      var raw = {
        contactId: this.profile.id,
        firstName: this.profile.firstName,
        middleName: this.profile.middleName,
        lastName: this.profile.lastName,
        nickname: this.profile.nickName,
        mobilePhone: this.profile.mobilePhone,
        gender: this.profile.gender,
        dateOfBirth: this.profile.dateOfBirth,
        tsaPrecheckNumber: this.profile.tsaPrecheckNumber,
      };
      this.$app.huddleLabsServerCall("profile/travel-profile/save", raw );
    },
    setRegistrationProfile() {
      var raw = {
        id: this.$store.state.meetings.meetingInfo.attendeeId,
        events: ["profileSaved"],
      };
      this.$app.huddleLabsServerCall("meetings/attendee/save", raw);
    },
    setRegistrationTime() {
      var raw = {
        id: this.$store.state.meetings.meetingInfo.attendeeId,
        events: ["registrationStarted"],
      };
      this.$app.huddleLabsServerCall("meetings/attendee/save", raw);
    },
  },
  computed: {
    profile: {
      get() {
        return this.$store.getters["travellersAndTrips/getCurrentTravellerProfile"];
      },
      set(value) {
        this.$store.commit("travellersAndTrips/setCurrentTravellerProfile", value);
      }
    }
  },
  mounted() {

    this.setRegistrationTime();

  },
};
</script>

<style lang="scss" scoped>
// mobile
@media screen and (max-width: 1023px) {
  .profile {
    margin: auto;
  }
}
// pc
@media screen and (min-width: 1024px) {
  .profile {
    margin: auto;
  }
}
</style>
